import { mapGetters, mapState } from 'vuex'
import appointmentForm from './appointmentForm/appointmentForm.vue'
import AppointmentService from '../../../services/appointment/appointmentService'

export default {
    data() {
        return {
            activeStep: 0,
            sendingDelivery: false,
            appointmentId: ''
        }
    },
    components: {
        appointmentForm
    },
    computed: {
        ...mapState('delivery', {
            patient: 'patient',
            provider: 'provider',
            orderDetails: 'orderDetails',
            selectedMedicines: 'selectedMedicines',
            state: 'state',
            city: 'city',
            schedule: 'schedule',
            scheduleName: 'scheduleName',
            //address: 'setBranchAddress',
            observations: 'observations',
            scheduleRange: 'scheduleRange',
            scheduleRangeAppointment: 'scheduleRangeAppointment',
            deliveryPointAddress: 'deliveryPointAddress',
            deliveryPointName: 'deliveryPointName',
            deliveryPoint: 'deliveryPoint',
            appointmentDate: 'appointmentDate',
            phone: 'phone',
            cellPhone: 'cellPhone',
        }),
        ...mapState('auth', [
            'user',
            'identification',
            'identificationType',
            'patientName'
        ]),
        ...mapGetters('delivery', {
            slidingScaleFee: 'slidingScaleFee',
            shippingDate: 'shippingDate'
        })
    },
    methods: {
        nextStep() {
            this.activeStep += 1;
        },
        previousStep() {
            this.activeStep -= 1;
        },
        goHome() {
            this.$router.push('/home')
        },
        async sendAppointment() {
            this.sendingDelivery = true
            try {
                let formData = {
                    patient: {
                        type: this.identificationType,
                        document: this.identification,
                        fullname: this.patientName,
                        phoneNumber: this.phone,
                        cellPhoneNumber: this.cellPhone
                    },
                    city: this.city,
                    date: this.appointmentDate,
                    scheduleRange: this.schedule,
                    deliveryPoint: this.deliveryPoint,
                    observation: this.observation,
                    userIsAdmin: false
                };

                const response = await AppointmentService.saveAppointment(formData);
                this.appointmentId = response.data.id
                this.sendingDelivery = false
                this.nextStep()
            } catch (error) {
                console.log(error)
                const message = this.$t('app.components.delivery.an-error-ocurred-registering-delivery');
                this.$buefy.toast.open({ message, type: 'is-danger' })
                this.sendingDelivery = false
            }
        },
        getOrderDetails(orderDetails) {
            return orderDetails.map(orderDetail => {
                orderDetail.medicines = orderDetail.medicines.map(medicine => {
                    medicine.orderCode = medicine.orderDetailCode
                    medicine.count = medicine.quantity
                    return medicine
                })
                return orderDetail
            })
        },
    }
}